import * as React from 'react';
export var TeaserCarouselItem = function (_a) {
    var children = _a.children, image = _a.image;
    return (React.createElement("div", { className: "wide-teaser text-center no-select", style: { backgroundImage: "url(".concat(image, ")") } }, children));
};
//# sourceMappingURL=TeaserCarouselItem.js.map